import clsx from 'clsx'
import type { ReactNode } from 'react'

type Variant = 'card' | 'plain'

const variantStyles: { [key in Variant]: string } = {
  card: 'rounded-2xl border border-gray-200/90 bg-white p-6 shadow-sm',
  plain: '',
}

interface Props {
  children: ReactNode
  className?: string
  variant?: Variant
}

const AdminSection = ({ children, className, variant = 'card' }: Props) => {
  return <section className={clsx(variantStyles[variant], className)}>{children}</section>
}

export default AdminSection
